import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AdMutationResult, AdsApiResponse } from './types';
import { ADS_QUERY_KEY } from './useGetAds';

type MutationParams = {
  adId: string;
  /** STAN DOCELOWY, nie delta — backend sam policzy, co dołożyć, a co skasować. */
  hotelIds: string[];
};

/**
 * Ustawia listę hoteli, w których reklama ma być widoczna — nadpisuje
 * `assigned_hotels` w katalogu. Tym samym wywołaniem zdejmuje się reklamę
 * z pojedynczego hotelu (wysyłając listę bez niego).
 */
export const useAssignAdToHotels = (
  options?: UseMutationOptions<AdMutationResult, AxiosError, MutationParams>,
): UseMutationResult<AdMutationResult, AxiosError, MutationParams> => {
  const queryClient = useQueryClient();

  return useMutation<AdMutationResult, AxiosError, MutationParams>({
    mutationFn: async ({ adId, hotelIds }) => {
      const res = await axiosInstance.put<AdsApiResponse<AdMutationResult>>(
        '/v3-assignAdHotels',
        { id: adId, hotelIds },
      );
      return res.data.data;
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ADS_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};
